module.exports = __webpack_public_path__ + "static/img/league.990a326.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/league.png
// module id = djgx
// module chunks = 3